import React from "react";
import Post from "../../components/Post";
import { Loader } from "semantic-ui-react";
import PostDetailedHtmlHead from "./components/PostDetailedHtmlHead";

export const PostDetailedContent = props => {
  if (!props.post || !props.post._id) {
    return (
      <div className="padded">
        <PostDetailedHtmlHead />
        <Loader size="large" active inline="centered" />
      </div>
    );
  }

  return (
    <div className="individual-post">
      <PostDetailedHtmlHead post={props.post} />
      <Post
        post={props.post}
        animationClass={props.animationClass}
        recommendedPostsAnimationClass={props.recommendedPostsAnimationClass}
        container="postpage"
      />
    </div>
  );
};

export default PostDetailedContent;



// WEBPACK FOOTER //
// ./src/scenes/PostDetailed/PostDetailedContent.js